<button
  mat-icon-button
  class="mw-arrow-toggler"
  [class.mw-arrow-toggler--remove-hover]="removeHover"
  (click)="onToggle()"
  [disableRipple]="true"
  [@rotatedState]="state"
>
  <mat-icon>keyboard_arrow_down</mat-icon>
</button>
